function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdownFill({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10.1484 4.89793L6.39844 8.64793C6.34618 8.70037 6.28408 8.74198 6.21571 8.77037C6.14734 8.79876 6.07403 8.81337 6 8.81337C5.92597 8.81337 5.85266 8.79876 5.78429 8.77037C5.71592 8.74198 5.65382 8.70037 5.60156 8.64793L1.85156 4.89793C1.74589 4.79226 1.68652 4.64893 1.68652 4.49949C1.68652 4.35005 1.74589 4.20673 1.85156 4.10105C1.95723 3.99538 2.10056 3.93602 2.25 3.93602C2.39944 3.93602 2.54276 3.99538 2.64844 4.10105L6.00047 7.45308L9.3525 4.10059C9.45817 3.99491 9.60149 3.93555 9.75094 3.93555C9.90038 3.93555 10.0437 3.99491 10.1494 4.10059C10.255 4.20626 10.3144 4.34958 10.3144 4.49902C10.3144 4.64847 10.255 4.79179 10.1494 4.89746L10.1484 4.89793Z",
    fill: "#AEB3C7",
    style: {
      fill: "#AEB3C7",
      fill: "color(display-p3 0.6824 0.7020 0.7804)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownFill);
export default __webpack_public_path__ + "static/media/dropdown-fill.591a520bc8d2d834f80ea07f822ea1ec.svg";
export { ForwardRef as ReactComponent };